import Title from "segments/desktop/core-components/title/title";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import PictureComponent from "components/core/picture/picture-component";
import { XS, XS_ML } from "constants/sizes";
import { componentStyles } from "./product-tab-title.scss";
import classNames from "classnames";

const ProductTabTitle = (props) => {
  const { title, body, productImage, selectedProductImage, isSelected } = props;
  return (
    <div
      className={classNames("product-title", {
        "selected-logo": isSelected,
        "logo-exists": selectedProductImage
      })}
    >
      <div className="product-logo-wrapper">
        <div className="product-logo">
          <PictureComponent src={productImage} />
        </div>
        <div className="selected-product-logo">
          <PictureComponent src={selectedProductImage} />
        </div>
      </div>
      <div className="product-tab-title-text">
        <Title titleSize={XS_ML} title={title} titleClassName="product-tab-title" />
        <Paragraph body={body} textSize={XS} />
      </div>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default ProductTabTitle;
